import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./App.tsx";
import "./index.css";
import { ClerkProvider } from "@clerk/clerk-react";
import { setMobileToken } from "./store/session/slice.ts";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://e289136a690a28b0fdd549e75d9db742@o4508891576795136.ingest.us.sentry.io/4508893700423680",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/api\.my\.softwareformovers\.com\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

// if (!PUBLISHABLE_KEY) {
//   throw new Error("Missing Publishable Key");
// }

window.addEventListener("mobileTokenReady", () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mobileToken = (window as any).mobileToken;
  store.dispatch(setMobileToken(mobileToken));
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      console.log("Service worker registered:", registration);
    })
    .catch((error) => {
      console.error("Service worker registration failed:", error);
    });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ClerkProvider
        publishableKey="pk_live_Y2xlcmsubXkuc29mdHdhcmVmb3Jtb3ZlcnMuY29tJA"
        afterSignOutUrl="/"
        appearance={{
          elements: {
            footer: "hidden",
          },
        }}
      >
        <App />
      </ClerkProvider>
    </Provider>
  </React.StrictMode>
);
